
angular.module('listviewModule').component('listviewRowImageViewer', {
	templateUrl: 'listviewRowImageViewer/listviewRowImageViewer.html',
	bindings: {
		item: '=',
		imageIndex: '@',
		searchType: '@',
		useFullScreenPopup: '<',
		onSaveScrollPosition: '&',
		isForBuilding: '<'
	},
	controller: ['$element', '$window', '$timeout', 'PubSub', function($element, $window, $timeout, PubSub) {
		this.pageType = window.pageType;
		var ctrl = this;
		this.saveScrollPosition = function() {
			this.onSaveScrollPosition();
		};

		this.addCloseButton = function() {
			var container = angular.element(document.querySelector('.w_fs_gallery .w_fs_gallery_cont'));
			var closeButton = angular.element('<div class="w_fs_close">&nbsp;</div>');
			var gallery = angular.element(document.querySelector('.w_fs_gallery'));
			angular.element(container).append(closeButton);

			closeButton.bind('click', function() {
				this.content[0].remove();
			});

			this.content = gallery;
		};
	}]
});
